import { config } from 'config';
import custom_en from './custom_en/translation.json';
import custom_es from './custom_es/translation.json';
const { availableLanguages = ['es'], language = 'default' } = config;

const translations = {
    ...(availableLanguages.includes('en') && {
        en: {
            translation: {
                ...require(`./${ language.toLowerCase() }_en/translation.json`),
                ...custom_en
            }
        }
    }),
    ...(availableLanguages.includes('es') && {
        es: {
            translation: {
                ...require(`./${ language.toLowerCase() }_es/translation.json`),
                ...custom_es
            }
        }
    })
};

export default translations;
